import request from '@/utils/request'


// 查询用户弹幕列表
export function listVideo(query) {
  return request({
    url: '/video/video-barrage/list',
    method: 'get',
    params: query
  })
}

// 查询用户弹幕分页
export function pageVideo(query) {
  return request({
    url: '/video/video-barrage/page',
    method: 'get',
    params: query
  })
}

export function changeIsOpen(data) {
  return request({
    url: '/video/video-barrage/changeIsOpen',
    method: 'post',
    params: data
  })
}

// 查询用户弹幕详细
export function getVideo(data) {
  return request({
    url: '/video/video-barrage/detail',
    method: 'get',
    params: data
  })
}

// 新增用户弹幕
export function addVideo(data) {
  return request({
    url: '/video/video-barrage/add',
    method: 'post',
    data: data
  })
}

// 修改用户弹幕
export function updateVideo(data) {
  return request({
    url: '/video/video-barrage/edit',
    method: 'post',
    data: data
  })
}

// 删除用户弹幕
export function delVideo(data) {
  return request({
    url: '/video/video-barrage/delete',
    method: 'post',
    data: data
  })
}
